import {
  GETUPDATECONFIGURATION_SUCCESS,
  GETUPDATECONFIGURATION_FAILED,
  RESET_GETUPDATECONFIGURATION,
  LOADING_GETUPDATECONFIGURATION,
  NETWORK_ERROR_GETUPDATECONFIGURATION,
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetGetUpdateConfigurationList = () => {
  return { type: RESET_GETUPDATECONFIGURATION };
};

const getUpdateConfigurationList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUPDATECONFIGURATION });
    await partnerServices
      .post("getUpdateConfiguration", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getUpdateConfigurationListsuccess(res.data));
            break;
          default:
            dispatch(getUpdateConfigurationListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: NETWORK_ERROR_GETUPDATECONFIGURATION, payload: err });
      });
  };
function getUpdateConfigurationListsuccess(data) {
  return {
    type: GETUPDATECONFIGURATION_SUCCESS,
    payload: data,
  };
}
function getUpdateConfigurationListFailed(data) {
  return {
    type: GETUPDATECONFIGURATION_FAILED,
    payload: data,
  };
}

export { resetGetUpdateConfigurationList, getUpdateConfigurationList };
